import React from "react";
import "../styles/TeamSection.css";

const teamMembers = [
  {
    name: "Benjamin Ekow Asem-Mensah",
    title: "Co-Founder & Lead Startup Consultant",
    image: "/ceo.jpg",
  },
  {
    name: "Alfred Eli K. Dei ",
    title: "Co-Founder and Legal & Compliance HD",
    image: "/Alfred.jpg",
  },
  {
    name: "Terrick Nii Obodai Torgbor ",
    title: "HD. of Digital Marketing & Research",
    image: "/Terrick.jpeg.jpg",
  },
  {
    name: "Obed Otu Ayor",
    title: "Tech Lead",
    image: "/Obed.jpg",
  },
  {
    name: "Patrick Quaye",
    title: "HD. of Business Development",
    image: "/Patrick.jpeg.jpg",
  },
  {
    name: "Emmanuel Obeng ",
    title: "HD. of Finance ",
    image: "/Emma.jpg",
  },
  // {
  //   name: "Anita Nimo Gyamera",
  //   title: "HD. of Human Resources",
  //   image: "../assets/account.png",
  // },
];

const TeamSection = () => {
  return (
    <div className="team-section">
      <h2 className="team-title">Meet Our Team</h2>
      <p className="team-subtitle">Passionate. Productive. Expert</p>
      <section className="team-membership">
        <div className="team-grid">
          {teamMembers.map((member, index) => (
            <div className="team-member" key={index}>
              <div className="team-image-wrapper">
                <img src={member.image} alt={member.name} />
              </div>
              <h3 className="team-member-name">{member.name}</h3>
              <p className="team-member-title">{member.title}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default TeamSection;
